import React from "react";
import { Link } from "react-router-dom";
import { Sparkle, Storefront, Target } from "@phosphor-icons/react";
import { AISalesConversation } from "@/components/AISalesConversation";
import { ChannelOptIn } from "@/components/ChannelOptIn";
import { useAuth } from "@/context/AuthContext";

export default function AISales() {
  const { isBusiness, isStaff } = useAuth();
  return (
    <div className="mx-auto flex h-[calc(100vh-8rem)] max-w-2xl flex-col" data-testid="ai-sales-page">
      <div className="flex items-center justify-between gap-3 border-b border-border pb-4">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary/15 text-primary"><Sparkle size={24} weight="fill" /></div>
          <div>
            <h1 className="font-display text-2xl font-semibold tracking-tight">iYeneh Assistant</h1>
            <p className="text-xs text-muted-foreground">Your 24/7 SI — get set up, buy, and get help in seconds</p>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          {(isBusiness || isStaff) && (
            <Link to="/app/ai-sales/hunter" data-testid="ai-sales-hunter-link"
              className="flex items-center gap-1.5 rounded-full bg-primary px-3 py-2 text-xs font-semibold text-primary-foreground transition-colors hover:opacity-90">
              <Target size={15} weight="fill" /> Sales console
            </Link>
          )}
          <Link to="/app/ai-sales/plans" data-testid="ai-sales-plans-link"
            className="flex items-center gap-1.5 rounded-full border border-border px-3 py-2 text-xs font-semibold transition-colors hover:border-primary">
            <Storefront size={15} weight="fill" /> For business
          </Link>
        </div>
      </div>
      <ChannelOptIn />
      <div className="flex-1 overflow-hidden">
        <AISalesConversation showRecommendations />
      </div>
    </div>
  );
}
